import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { capitalize, find, some } from 'lodash-es';
import { getBillingCycle } from 'src/app/shared/helpers/helpers';

@Component({
  selector: 'app-billing-cycle-change-popup',
  templateUrl: './billing-cycle-change-popup.component.html',
  styleUrls: ['./billing-cycle-change-popup.component.scss']
})
export class BillingCycleChangeComponent implements OnInit {
  

  selectedBillingCycle : {
    value: string,
    displayValue: string
  };
    
  cycles = new Array<{value: string, displayValue: string}>();
  change(value: any) {
      this.selectedBillingCycle = find(this.cycles, (x) => {
        return x.value == value;
      });
  };
  submitBillingChange($event) {
    this.thisDialogRef.close(this.selectedBillingCycle.value);
  }

  constructor(@Optional() public thisDialogRef: MatDialogRef<BillingCycleChangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.init();
  }

  init(){
    this.cycles = this.data.subscriptionPlans.filter((item) => {
      return item.id == this.data.currentlyActiveCompanySubscription.subscriptionPlan.id || item.billingDays != this.data.currentlyActiveCompanySubscription.subscriptionPlan.billingDays;
    }).sort((planA, planB)=>{
      return planA.basePrice - planB.basePrice;
    }).map((item) => {
      return {
        value: item.id,
        displayValue: `$${item.basePrice} Billed ${capitalize(getBillingCycle(item.billingDays, false))}`
      }
    });
    this.selectedBillingCycle = this.cycles.filter(x=> x.value == this.data.currentlyActiveCompanySubscription.subscriptionPlan.id)[0];
  }

  closePopup(){
    this.thisDialogRef.close('cancel');
  }
     
}
